// extracted by mini-css-extract-plugin
export default {"header":"limited_time-module__header___20wY"};